"use client";

import { createContext, PropsWithChildren, useContext, useState } from "react";

type SidebarContextType = {
  isOpen: boolean;
  open: (Component: JSX.Element) => void;
  close: () => void;
  Component: JSX.Element | null;
};

export const SidebarContext = createContext<SidebarContextType>({
  isOpen: false,
  open: () => null,
  close: () => null,
  Component: null,
});

export const SidebarContextProvider = ({ children }: PropsWithChildren) => {
  const [sidebarComponent, setSidebarComponent] = useState<JSX.Element | null>(
    null
  );

  return (
    <SidebarContext.Provider
      value={{
        Component: sidebarComponent,
        isOpen: Boolean(sidebarComponent),
        open: (component) => setSidebarComponent(component),
        close: () => setSidebarComponent(null),
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const { isOpen, open, close, Component } = useContext(SidebarContext);

  return { isOpen, open, close, Component };
};
